import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { getErrorString } from "../display/ErrorStrings";
import RejectedAccountItemsPage from "../containers/RejectedAccountItemsPage";
import PaidAccountItemsPage from "../containers/PaidAccountItemsPage";
import OutstandingAccountItemsPage from "../containers/OutstandingAccountItemsPage";
import ConsolidatedAccountItemsPage from "../containers/ConsolidatedAccountItemsPage";
import CdisbSummaryPage from "../containers/CdisbSummaryPage";
import CdisbDetailPage from "../containers/CdisbDetailPage";
import AchPaidAccountItemsPage from "../containers/AchPaidAccountItemsPage";
import AchExceptionAccountItemsPage from "../containers/AchExceptionAccountItemsPage";
import AccountReconciliationPage from "../containers/AccountReconciliationPage";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
});

class HomePageReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      searchError: "",
      notifyString: "",
      accounts: [],
      reasons: [],
      options: [],
      transCodes: [],
      returnCodes: [],
      arpFormats: [],
      selectedOptionIndex: -1,
      selectedOption: {},
      reportChange: false,
      transitChange: false,
      selectedTransit: "",
      accountsForTransit: [],
      selectedAccount: {},
      scrubTimeLeft: 0,
      crtTime: "",
    };
    this.onReportChange = this.onReportChange.bind(this);
  }

  onReportChange(e) {
    this.setState({ selectedOptionIndex: e.target.value });
    this.setState({ selectedOption: this.state.options[e.target.value] });
    this.setState({ reportChange: true });
  }

  componentDidUpdate() {
    if (this.state.reportChange) {
      this.setState({ reportChange: false });
    }
    if (this.state.transitChange) {
      this.setState({ transitChange: false });
    }
  }

  componentDidMount() {
    this.props.prefs.secureToken = this.props.secureToken;
    fetch("on_home_page_reports_entry", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.props.prefs),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
        } else {
          this.setState({ accounts: reply.accounts });
          if (reply.accounts.length > 0) {
            this.setState({ selectedTransit: reply.accounts[0].transit });
            let accountsForTransit = reply.accounts[0].accountsData;
            this.setState({ accountsForTransit: accountsForTransit });
            this.setState({ selectedAccount: accountsForTransit[0] });
            this.configAccount(accountsForTransit[0]);
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  configAccount(selectedAccount) {
    this.setState({ selectedOption: {} });
    this.setState({ selectedOptionIndex: -1 });
    this.setState({ notifyString: "" });
    this.setState({ searchError: "" });

    fetch("on_home_page_report_config", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        accountData: selectedAccount,
        reportTypes: this.props.prefs.reportTypes,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ searchError: reply.errorString });
        } else {
          if (reply.options.length === 0) {
            this.setState({
              notifyString: "No permission. No report could be generated.",
            });
          } else {
            this.setState({ reasons: reply.reasons });
            this.setState({ transCodes: reply.transCodes });
            this.setState({ returnCodes: reply.returnCodes });
            this.setState({ arpFormats: reply.arpFormats });
            this.setState({ options: reply.options });
            this.setState({ selectedOption: reply.options[0] });
            this.setState({ selectedOptionIndex: reply.options[0].index });
            this.setState({ scrubTimeLeft: reply.scrubTimeLeft });
            var today = new Date();
            var time =
              ("0" + today.getHours()).slice(-2) +
              ":" +
              ("0" + today.getMinutes()).slice(-2);
            this.setState({ crtTime: time });
          }
        }
      })
      .catch((error) => {
        this.setState({
          searchError:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  handleTransitChange(e) {
    let accounts = this.state.accounts;
    let i;
    for (i = 0; i < accounts.length; i++) {
      if (accounts[i].transit === e.target.value) {
        this.setState({ selectedTransit: accounts[i].transit });
        let accountsForTransit = accounts[i].accountsData;
        this.setState({ accountsForTransit: accountsForTransit });
        this.setState({ selectedAccount: accountsForTransit[0] });
        this.configAccount(accountsForTransit[0]);
        break;
      }
    }
    this.setState({ transitChange: true });
  }

  handleAccountChange(e) {
    let accountNum = e.target.value;
    let i;
    for (i = 0; i < this.state.accountsForTransit.length; i++) {
      if (accountNum === this.state.accountsForTransit[i].account) {
        this.setState({ selectedAccount: this.state.accountsForTransit[i] });
        this.configAccount(this.state.accountsForTransit[i]);
        break;
      }
    }
  }

  render() {
    let transits = this.state.accounts;
    let accountsForTransit = this.state.accountsForTransit;
    let { t } = this.props;
    return (
      <div style={{ margin: 20 }}>
        {this.state.errorString.length > 0 && (
          <Typography color="error" variant="h6">
            &nbsp;&nbsp;{this.state.errorString}
          </Typography>
        )}
        {this.state.accounts.length > 0 && !this.state.transitChange && (
          <div style={{ margin: 20 }}>
            <Typography variant="body1" color="primary">
              {t("transit.label")}&nbsp;
              <NativeSelect
                style={{ height: 24, verticalAlign: "textTop", margin: 0 }}
                defaultValue={this.state.selectedTransit}
                input={<Input id="transit" />}
                onChange={(event) => this.handleTransitChange(event)}
              >
                {transits.map((n) => {
                  return <option value={n.transit}>{n.transit}</option>;
                })}
              </NativeSelect>
              &nbsp;&nbsp;{t("account.label")}&nbsp;
              <NativeSelect
                style={{ height: 24, verticalAlign: "textTop", margin: 0 }}
                defaultValue={this.state.selectedAccount.account}
                input={<Input id="account" />}
                onChange={(event) => this.handleAccountChange(event)}
              >
                {accountsForTransit.map((n) => {
                  return <option value={n.account}>{n.account}</option>;
                })}
              </NativeSelect>
            </Typography>
          </div>
        )}
        {this.state.notifyString.length > 0 && (
          <Typography color="primary" variant="subheading">
            &nbsp;&nbsp;{this.state.notifyString}
          </Typography>
        )}
        {this.state.searchError.length > 0 && (
          <Typography color="error" variant="h6">
            &nbsp;&nbsp;{this.state.searchError}
          </Typography>
        )}
        {this.state.selectedOptionIndex !== -1 && (
          <div>
            {(this.state.selectedOption.id === "N" ||
              this.state.selectedOption.id === "C" ||
              this.state.selectedOption.id === "H" ||
              this.state.selectedOption.id === "D" ||
              this.state.selectedOption.id === "RETURNED") &&
              !this.state.reportChange && (
                <RejectedAccountItemsPage
                  onReportChange={this.onReportChange}
                  reasons={this.state.reasons}
                  returnCodes={this.state.returnCodes}
                  reports={this.state.options}
                  option={this.state.selectedOption}
                  history={this.props.history}
                  accountObject={this.state.selectedAccount}
                  scrubTimeLeft={this.state.scrubTimeLeft}
                  uiExclusionsList={this.props.uiExclusionsList}
                  viewOnly={this.props.viewOnly}
                  secureToken={this.props.secureToken}
                  crtTime={this.state.crtTime}
                />
              )}
            {(this.state.selectedOption.id === "P" ||
              this.state.selectedOption.id === "PNI") &&
              !this.state.reportChange && (
                <PaidAccountItemsPage
                  onReportChange={this.onReportChange}
                  reasons={this.state.reasons}
                  reports={this.state.options}
                  option={this.state.selectedOption}
                  history={this.props.history}
                  accountObject={this.state.selectedAccount}
                  uiExclusionsList={this.props.uiExclusionsList}
                  viewOnly={this.props.viewOnly}
                  secureToken={this.props.secureToken}
                />
              )}
            {this.state.selectedOption.id === "O" &&
              !this.state.reportChange && (
                <OutstandingAccountItemsPage
                  onReportChange={this.onReportChange}
                  reasons={this.state.reasons}
                  reports={this.state.options}
                  option={this.state.selectedOption}
                  history={this.props.history}
                  accountObject={this.state.selectedAccount}
                  uiExclusionsList={this.props.uiExclusionsList}
                  viewOnly={this.props.viewOnly}
                  secureToken={this.props.secureToken}
                />
              )}
            {this.state.selectedOption.id === "K" &&
              !this.state.reportChange && (
                <ConsolidatedAccountItemsPage
                  onReportChange={this.onReportChange}
                  reasons={this.state.reasons}
                  reports={this.state.options}
                  option={this.state.selectedOption}
                  history={this.props.history}
                  accountObject={this.state.selectedAccount}
                  uiExclusionsList={this.props.uiExclusionsList}
                  viewOnly={this.props.viewOnly}
                  secureToken={this.props.secureToken}
                />
              )}
            {this.state.selectedOption.id === "cdisb_summary" &&
              !this.state.reportChange && (
                <CdisbSummaryPage
                  onReportChange={this.onReportChange}
                  reasons={this.state.reasons}
                  reports={this.state.options}
                  option={this.state.selectedOption}
                  history={this.props.history}
                  accountObject={this.state.selectedAccount}
                  uiExclusionsList={this.props.uiExclusionsList}
                  viewOnly={this.props.viewOnly}
                  secureToken={this.props.secureToken}
                />
              )}
            {this.state.selectedOption.id === "cdisb_detail" &&
              !this.state.reportChange && (
                <CdisbDetailPage
                  onReportChange={this.onReportChange}
                  reasons={this.state.reasons}
                  reports={this.state.options}
                  option={this.state.selectedOption}
                  history={this.props.history}
                  accountObject={this.state.selectedAccount}
                  uiExclusionsList={this.props.uiExclusionsList}
                  viewOnly={this.props.viewOnly}
                  secureToken={this.props.secureToken}
                />
              )}
            {this.state.selectedOption.id === "A" &&
              !this.state.reportChange && (
                <AchPaidAccountItemsPage
                  onReportChange={this.onReportChange}
                  reports={this.state.options}
                  option={this.state.selectedOption}
                  history={this.props.history}
                  accountObject={this.state.selectedAccount}
                  uiExclusionsList={this.props.uiExclusionsList}
                  viewOnly={this.props.viewOnly}
                  secureToken={this.props.secureToken}
                />
              )}
            {this.state.selectedOption.id === "E" &&
              !this.state.reportChange && (
                <AchExceptionAccountItemsPage
                  onReportChange={this.onReportChange}
                  reports={this.state.options}
                  option={this.state.selectedOption}
                  history={this.props.history}
                  accountObject={this.state.selectedAccount}
                  uiExclusionsList={this.props.uiExclusionsList}
                  viewOnly={this.props.viewOnly}
                  scrubTimeLeft={this.state.scrubTimeLeft}
                  crtTime={this.state.crtTime}
                  secureToken={this.props.secureToken}
                />
              )}
            {this.state.selectedOption.id === "R" &&
              !this.state.reportChange && (
                <AccountReconciliationPage
                  onReportChange={this.onReportChange}
                  reports={this.state.options}
                  option={this.state.selectedOption}
                  history={this.props.history}
                  accountObject={this.state.selectedAccount}
                  transCodes={this.state.transCodes}
                  arpFormats={this.state.arpFormats}
                  uiExclusionsList={this.props.uiExclusionsList}
                  viewOnly={this.props.viewOnly}
                  secureToken={this.props.secureToken}
                />
              )}
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(HomePageReports));
